export const development = {
  SITE_KEY: '6LeG4wccAAAAACmY1Yw0LwJ7_GDerIkQ7bPmAOsO'
}
export const staging = {
  SITE_KEY: '6LeG4wccAAAAACmY1Yw0LwJ7_GDerIkQ7bPmAOsO'
}
export const production = {
  SITE_KEY: '6LeIV5ceAAAAABfVCTV91Mnz7RdajDb5Z882iYWk'
}
